import { initialCheckoutInitState as o } from "./checkoutInit.action.js";
var u = {
  products: null,
  delivery: null,
  orderNumber: "",
  comment: "",
  availability: {},
  outOfStockHandling: {}
}, h = (e) => ({
  setCheckoutProducts: (t) => e((c) => ({ checkout: {
    ...c.checkout,
    products: t
  } })),
  setCheckoutDelivery: (t) => e((c) => ({ checkout: {
    ...c.checkout,
    delivery: JSON.parse(JSON.stringify(t))
  } })),
  setCheckoutOrderNumber: (t) => e((c) => ({ checkout: {
    ...c.checkout,
    orderNumber: t
  } })),
  setCheckoutComment: (t) => e((c) => ({ checkout: {
    ...c.checkout,
    comment: t
  } })),
  setCheckoutAvailability: (t) => e((c) => ({ checkout: {
    ...c.checkout,
    availability: t
  } })),
  setCheckoutOutOfStockHandling: (t) => e((c) => ({ checkout: {
    ...c.checkout,
    outOfStockHandling: t
  } })),
  clearCheckout: () => e({
    checkout: u,
    checkoutInit: o
  })
});
export {
  h as createCheckoutActions,
  u as initialCheckoutState
};

//# sourceMappingURL=checkout.action.js.map